/**
 * @generated SignedSource<<75ce93e358ea24be648aaccc4d325283>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type importCatalogListQuery$variables = {
  category?: string | null;
  macroCategory?: string | null;
  provider: ProductProvider;
};
export type importCatalogListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"importCatalogPaginationFragment__providerProducts">;
};
export type importCatalogListQuery = {
  response: importCatalogListQuery$data;
  variables: importCatalogListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "category"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "macroCategory"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provider"
},
v3 = {
  "kind": "Variable",
  "name": "category",
  "variableName": "category"
},
v4 = {
  "kind": "Variable",
  "name": "macroCategory",
  "variableName": "macroCategory"
},
v5 = {
  "kind": "Variable",
  "name": "provider",
  "variableName": "provider"
},
v6 = [
  {
    "kind": "Literal",
    "name": "after",
    "value": "1"
  },
  (v3/*:: as any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  (v4/*:: as any*/),
  (v5/*:: as any*/),
  {
    "kind": "Literal",
    "name": "search",
    "value": ""
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "importCatalogListQuery",
    "selections": [
      {
        "args": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "importCatalogPaginationFragment__providerProducts"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "importCatalogListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "ProviderProductsConnection",
        "kind": "LinkedField",
        "name": "providerProducts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProviderProductsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductProviderListItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "filters": [
          "search",
          "category",
          "macroCategory",
          "provider"
        ],
        "handle": "connection",
        "key": "importCatalogPaginationFragment_providerProducts",
        "kind": "LinkedHandle",
        "name": "providerProducts"
      }
    ]
  },
  "params": {
    "cacheID": "3cd3af28f3ea17556a221560d33d3e5b",
    "id": null,
    "metadata": {},
    "name": "importCatalogListQuery",
    "operationKind": "query",
    "text": "query importCatalogListQuery(\n  $provider: ProductProvider!\n  $category: String\n  $macroCategory: String\n) {\n  ...importCatalogPaginationFragment__providerProducts_4xtz7X\n}\n\nfragment importCatalogPaginationFragment__providerProducts_4xtz7X on Query {\n  providerProducts(first: 1, after: \"1\", search: \"\", category: $category, macroCategory: $macroCategory, provider: $provider) {\n    edges {\n      node {\n        id\n        name\n        imageUrl\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d881df19976dec8b7bae96bbf6f119a9";

export default node;
